import { WholesaleCatalogType } from '@cbgms/api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@carsys/form'
import { useFormikContext } from 'formik'
import { IFormValues } from './types'

export const hasTecDocFields = (selectedCatalogType: WholesaleCatalogType) => Boolean(selectedCatalogType === WholesaleCatalogType.TecDoc)

export const CatalogFieldsTecDoc = () => {
  const { t } = useTranslation()
  const {
    values: { wholesaleCatalogType }
  } = useFormikContext<IFormValues>()
  const renderTecDocFieldsInput = useMemo(() => hasTecDocFields(wholesaleCatalogType), [wholesaleCatalogType])

  if (!renderTecDocFieldsInput) return null
  return (
    <>
      <TextField name='TecDocOverrideProvider' label={t('wholesaler-catalog.TecDocOverrideProvider')} />
      <TextField name='TecDocOverrideAPIKey' label={t('wholesaler-catalog.TecDocOverrideAPIKey')} />
    </>
  )
}
